import { render, staticRenderFns } from "./RegionReg.vue?vue&type=template&id=8adf3398&scoped=true"
import script from "./RegionReg.vue?vue&type=script&lang=js"
export * from "./RegionReg.vue?vue&type=script&lang=js"
import style0 from "./RegionReg.vue?vue&type=style&index=0&id=8adf3398&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adf3398",
  null
  
)

export default component.exports